import script from "./ValidationIndicator.vue?vue&type=script&lang=ts&setup=true"
export * from "./ValidationIndicator.vue?vue&type=script&lang=ts&setup=true"

import "./ValidationIndicator.vue?vue&type=style&index=0&id=a2ae0bf2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2ae0bf2"]])

export default __exports__